import { useTranslation } from 'react-i18next';
import thankYou from '@assets/images/thank-you.webp';



interface ThankYouProps {
	registration?: boolean,
}


const ThankYou = (props: ThankYouProps) => {
	const { registration = false } = props;
	const { t } = useTranslation('web');

	return (
		<div className="app-page thank-you-page">
			
			<h1>{registration ? t('pages.thankYou.registrationHeader') : t('pages.thankYou.orderHeader')}</h1>

			<div className='thank-text'>
				<p>{registration ? t('pages.thankYou.registrationText1') : t('pages.thankYou.orderText1')}</p>
				<p>{registration ? t('pages.thankYou.registrationText2') : t('pages.thankYou.orderText2')}</p>
			</div>
			
			<div className='thank-image'>
				<img src={thankYou} alt='thank-you-photo' />	
			</div>

		</div>
	);
};

export default ThankYou;